module.exports = __webpack_public_path__ + "static/media/YF14_0.373917e7.jpg";